module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA4klEQVQ4jaWT4RHBQBCFP5kUoAQqoANSASpABaQCVBAlpBM64I/flJAOmDUbnpsTjPdr72327bvdS4vTFceQJzTuAW2P+xLPgdIEDp54h73wF2DmXGZE6ko7Ua2CIoV+d0cCHJ0wa6OG4rFfbeNO7tAZFMASyIFtUGziZ3fX1UQice7di8hMVi4yD/gXB9oJ71S5bbt7GRNIgnPl022Li3qleWwwaYQ7SqEO1MTX3wg0YQp0JH/5VSD7V+AcEu8EHg8l4uBrgUGEX8jPZKjCNSpsjTb1mNBHB/Uq7QUqJi8n4AZo6zAOZzg9JwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/subDevice/son_icon_type.png
// module id = 8HWY
// module chunks = 4